import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
@Injectable({ providedIn: 'root' })
export class ThemeService {
    private readonly storageKey = 'theme';
    private currentTheme: 'light' | 'dark' = 'dark';

    setTheme(theme: 'light' | 'dark') {
        localStorage.setItem('themeMode', theme);
        const body = document.body;
        body.classList.remove('light-theme', 'dark-theme');
        body.classList.add(`${theme}-theme`);
        this.currentTheme = theme;
    }

    getTheme(): 'light' | 'dark' {
        return this.currentTheme;
    }
}
